import { Typography } from "@mui/material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { useTranslation } from "react-i18next";
import { SurveyAppointmentSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/surveyAppointmentSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: SurveyAppointmentSubtypeDataModel;
}

export default function SurveyAppointmentSubtypeSummary(props: Props) {
    const { t } = useTranslation();

    if (props.subtypeData.noEventViable) {
        return <Typography sx={{ textOverflow: "ellipsis" }}>{t("incentivationPage.surveyAppointment.noEventSelected")}</Typography>
    }

    return <Typography sx={{ textOverflow: "ellipsis" }}>{
        props.subtypeData.eventAnswers.map((e) => e.event.title).join(", ")
    }</Typography>
}
